import React from 'react';
import { WorkflowProps } from '@/types/workflow';
import AverageBioScore from '@/components/Analysis/BioScore/AverageBioScore';
import AssessmentComplete from '@/components/Analysis/BioScore/AssessmentComplete';
import styles from './styles.module.scss';

export const BioScoreResultsPanel: React.FC<WorkflowProps> = (props) => {
	return (
		<div className={styles.container}>
			<AverageBioScore {...props} activeSection={5} />
			<div className={styles.sectionDivider} />
			<AssessmentComplete {...props} activeSection={6} />
		</div>
	);
};
